"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceDesignRequestModelModelId = void 0;
exports.VoiceDesignRequestModelModelId = {
    ElevenMultilingualTtvV2: "eleven_multilingual_ttv_v2",
    ElevenTtvV3: "eleven_ttv_v3",
};
